// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.img-profilo .box-img {\n    MARGIN-BOTTOM: 20px;\n}\n\n.img-profilo img {\n    width: 200px;\n}", "",{"version":3,"sources":["webpack://./src/style/styleComponents/ImmagineProfilo.css"],"names":[],"mappings":";AACA;IACI,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["\n.img-profilo .box-img {\n    MARGIN-BOTTOM: 20px;\n}\n\n.img-profilo img {\n    width: 200px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
